'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/well-known-symbol-wrapped.js
// module id = 498
// module chunks = 0